import React, { useEffect, useState } from "react";
import 'moment-timezone';
import $ from 'jquery';
import SessionManager from "../../routes/SessionManager";
import CommonUtils from "../../util/CommonUtils";
import no_image from './../../assets/img/no-image.png';
import ImageResize from "../common/ImageResize";
import Moment from "react-moment";
import { Badge } from "antd";
import LiveCameraFeed from "../modals/LiveCameraFeed";
import AxisLiveCameraFeed from "../modals/AxisLiveCameraFeed";

function LocationCard(props) {
    let sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');

    const [location, setLocation] = useState(null);
    const [site, setSite] = useState(null);
    const [turnOnVideoStreaming, setTurnOnVideoStreaming] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [videoFit, setVideoFit] = useState('natural'); // 'natural' | 'contain' | 'cover'

    useEffect(() => {
        populateDefaults();
    }, []);

    // Start streaming when this card becomes featured or playInTile is active
    useEffect(() => {
        if (!props.compact || !location) return;
        if (props.isFeatured || props.playInTile) {
            const isConnected = location.location_operstatus === 'Connected';
            const liveMode = location.device_id && ((location.location_features && location.location_features.includes('s1')) || ['axis'].includes(location.location_device_type));
            const viewStreaming = user && user.site_selected && (site && site.site_view_streaming !== undefined ? site.site_view_streaming : true);
            if (isConnected && liveMode && viewStreaming) setTurnOnVideoStreaming(true);
        } else {
            setTurnOnVideoStreaming(false);
        }
    }, [props.isFeatured, props.playInTile, location]);

    const populateDefaults = async () => {
        let _s = await CommonUtils.getSite(props.site_id, user);
        setSite(_s);
        let _l = await CommonUtils.getLocation(props.location_id, { ...user, site_selected: { site_id: props.site_id } });
        setLocation(_l);
        if (props.onLocationLoaded && _l && _s) props.onLocationLoaded(_l, _s);
    }

    const streamVideo = (e) => {
        if (props.onFeatureStream) {
            props.onFeatureStream(site, location);
            return;
        }
        setTurnOnVideoStreaming(true);
        resizeVideoContent(e, true);
    }

    const stopVideo = async (e) => {
        await new Promise((resolve, reject) => setTimeout(resolve, 200));
        if ($('#close-player') && $('#close-player').length > 0) {
            $('#close-player').trigger('click');
        }

        setTurnOnVideoStreaming(false);
        resizeVideoContent(e);
    }

    let image = location ? "https://sitesupt-location-data.s3.amazonaws.com/cusr_" + location.customer_id + "/site_" + location.site_id + "/location_" + props.location_id + "/image_" + location.device_id + "_" + location.location_last_pic_pic_time + ".jpg" : no_image;

    let temperature = '';
    let humidity = '';
    let enable_live_mode = false;
    let enable_view_streaming = false;

    if (location) {
        temperature = Math.round(location.location_temperature, 2);
        temperature = temperature === -100 ? '' : temperature + " °F";

        humidity = Math.round(location.location_humidity, 2);
        humidity = humidity === -100 ? '' : humidity + " %";

        enable_view_streaming = user && user.site_selected && (user.site_selected.site_view_streaming === undefined ? true : user.site_selected.site_view_streaming);

        enable_live_mode = location.device_id && location.location_operstatus === 'Connected';
        if (enable_live_mode)
            enable_live_mode = ((location.location_features && location.location_features.includes('s1')) || (['axis'].includes(location.location_device_type)));
    }

    const resizeVideoContent = (e, isStart = false) => {
        $('.col-md-12').find('.video-btn').trigger('click');
        $('.location-card').removeClass('col-md-12').addClass('col-md-4');

        if (isStart)
            $(e.target).closest('.location-card').removeClass('col-md-4').addClass('col-md-12');
    }

    // Compact modern poster-tile card for exec dashboard
    if (props.compact) {
        const isConnected = location && location.location_operstatus === 'Connected';
        const canStream = location && location.device_id && ((location.location_features && location.location_features.includes('s1')) || ['axis', 'uniview'].includes(location.location_device_type));
        const streamingEnabled = site && (site.site_view_streaming !== undefined ? site.site_view_streaming : true);

        return (
            <React.Fragment>
                <div
                    onClick={() => !props.isFeatured && (site && location) && streamVideo(null)}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    style={{
                        position: 'relative',
                        borderRadius: '4px',
                        overflow: props.isFeatured ? (videoFit === 'natural' ? 'visible' : 'hidden') : 'hidden',
                        background: 'transparent',
                        cursor: props.isFeatured ? 'default' : (site && location ? 'pointer' : 'wait'),
                        ...(!props.isFeatured
                            ? { aspectRatio: '16/10' }
                            : videoFit !== 'natural' ? { aspectRatio: '16/9' } : {}
                        ),
                        boxShadow: isHovered && !props.isFeatured
                            ? '0 8px 24px rgba(0,0,0,0.45)'
                            : '0 2px 8px rgba(0,0,0,0.25)',
                        transform: isHovered && !props.isFeatured ? 'scale(1.03)' : 'scale(1)',
                        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    }}
                >
                    {/* snapshot: absolute fill on thumbnails; normal flow on featured (before stream) */}
                    {(!props.isFeatured || !turnOnVideoStreaming) && (
                        <ImageResize
                            className="d-block"
                            src={image || no_image}
                            resize_perc="0.2"
                            style={props.isFeatured ? {
                                width: '100%', height: 'auto', display: 'block', opacity: 0.7,
                            } : {
                                position: 'absolute', top: 0, left: 0,
                                width: '100%', height: '100%', objectFit: 'cover',
                                opacity: isHovered ? 1 : 0.88, transition: 'opacity 0.2s'
                            }}
                        />
                    )}

                    {/* Loading overlay — while location data is still fetching */}
                    {props.isFeatured && !location && (
                        <div style={{
                            position: 'absolute', inset: 0, zIndex: 20, borderRadius: '4px',
                            background: 'rgba(0,0,0,0.65)',
                            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '10px'
                        }}>
                            <i className="fa fa-circle-notch fa-spin fa-2x" style={{ color: '#fff' }} />
                            <span style={{ color: 'rgba(255,255,255,0.85)', fontSize: '12px' }}>Loading...</span>
                        </div>
                    )}

                    {/* Streaming unavailable overlay — when location can't stream */}
                    {props.isFeatured && location && !turnOnVideoStreaming && (!isConnected || !canStream || !streamingEnabled) && (
                        <div style={{
                            position: 'absolute', inset: 0, zIndex: 20, borderRadius: '4px',
                            background: 'rgba(0,0,0,0.75)',
                            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px',
                            padding: '20px'
                        }}>
                            <i className="fa fa-video-slash fa-2x" style={{ color: '#fff', opacity: 0.9 }} />
                            <div style={{ color: '#fff', fontSize: '14px', fontWeight: 600, textAlign: 'center' }}>
                                Streaming Unavailable
                            </div>
                            <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: '12px', textAlign: 'center', lineHeight: 1.5 }}>
                                {!isConnected && 'Camera is offline'}
                                {isConnected && !canStream && 'Camera does not support live streaming'}
                                {isConnected && canStream && !streamingEnabled && 'Streaming is disabled for this site'}
                            </div>
                        </div>
                    )}

                    {/* Live stream in tile — when playing but not featured */}
                    {turnOnVideoStreaming && !props.isFeatured && location && (
                        <div className="tile-stream" style={{ position: 'absolute', inset: 0, overflow: 'hidden', zIndex: 5 }}>
                            {['axis', 'uniview'].includes(location.location_device_type)
                                ? <AxisLiveCameraFeed site={site} zone={location} user={user} closeModal={() => setTurnOnVideoStreaming(false)} />
                                : <LiveCameraFeed site={site} zone={location} user={user} closeModal={() => setTurnOnVideoStreaming(false)} />
                            }
                        </div>
                    )}

                    {/* Live stream — layout depends on fit mode */}
                    {turnOnVideoStreaming && props.isFeatured && location && (
                        <div className="featured-stream" data-fit={videoFit} style={
                            videoFit !== 'natural'
                                ? { position: 'absolute', inset: 0, overflow: 'hidden', zIndex: 5 }
                                : { position: 'relative', width: '100%', zIndex: 5 }
                        }>
                            {['axis', 'uniview'].includes(location.location_device_type)
                                ? <AxisLiveCameraFeed site={site} zone={location} user={user} closeModal={() => setTurnOnVideoStreaming(false)} />
                                : <LiveCameraFeed site={site} zone={location} user={user} closeModal={() => setTurnOnVideoStreaming(false)} />
                            }
                        </div>
                    )}


                    {/* LIVE badge — always on top */}
                    <div style={{
                        position: 'absolute', top: '25px', left: '8px', zIndex: 20,
                        background: turnOnVideoStreaming ? '#e53935' : 'rgba(0,0,0,0.55)',
                        color: '#fff', fontSize: '9px', fontWeight: 800,
                        padding: '2px 7px', borderRadius: '4px',
                        letterSpacing: '1px', textTransform: 'uppercase',
                        display: 'flex', alignItems: 'center', gap: '5px',
                        boxShadow: turnOnVideoStreaming ? '0 0 8px rgba(229,57,53,0.7)' : '0 1px 4px rgba(0,0,0,0.4)',
                        transition: 'background 0.3s, box-shadow 0.3s',
                    }}>
                        <span style={{
                            width: '5px', height: '5px', borderRadius: '50%',
                            background: '#fff', display: 'inline-block',
                            animation: turnOnVideoStreaming ? 'livePulse 1s ease-in-out infinite' : (isConnected ? 'livePulse 1.4s ease-in-out infinite' : 'none')
                        }} />
                        LIVE
                    </div>

                    {/* top-right: fit controls + close button when featured */}
                    {props.isFeatured ? (
                        <div style={{
                            position: 'absolute', top: '8px', right: '8px',
                            display: 'flex', alignItems: 'center', gap: '4px', zIndex: 10
                        }}>
                            {turnOnVideoStreaming && ['natural', 'contain', 'cover'].map(fit => (
                                <span key={fit} title={fit === 'natural' ? 'Natural size' : fit === 'contain' ? 'Fit (show full frame)' : 'Fill (crop to fit)'}
                                    onClick={e => { e.stopPropagation(); setVideoFit(fit); }}
                                    style={{
                                        padding: '2px 7px', borderRadius: '4px', cursor: 'pointer',
                                        fontSize: '9px', fontWeight: 700, letterSpacing: '0.5px',
                                        background: videoFit === fit ? 'rgba(255,255,255,0.95)' : 'rgba(0,0,0,0.5)',
                                        color: videoFit === fit ? '#111' : '#fff',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.4)',
                                        textTransform: 'uppercase',
                                    }}>
                                    {fit === 'natural' ? 'Auto' : fit === 'contain' ? 'Fit' : 'Fill'}
                                </span>
                            ))}
                            <span style={{
                                width: '22px', height: '22px', borderRadius: '50%',
                                background: 'rgba(0,0,0,0.55)', color: '#fff',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: '13px', fontWeight: 700, cursor: 'pointer', lineHeight: 1,
                                boxShadow: '0 1px 4px rgba(0,0,0,0.4)'
                            }}
                                onClick={e => { e.stopPropagation(); props.onFeatureStream && props.onFeatureStream(site, location); }}
                            >✕</span>
                        </div>
                    ) : location && (
                        <span style={{
                            position: 'absolute', top: '10px', right: '10px',
                            width: '8px', height: '8px', borderRadius: '50%',
                            background: isConnected ? '#4caf50' : '#f44336',
                            boxShadow: isConnected ? '0 0 6px #4caf50' : 'none',
                            display: 'inline-block'
                        }} />
                    )}

                    {/* location name + site subtitle at bottom-left */}
                    <div style={!props.isFeatured ? {
                        color: '#fff',
                        position: 'absolute', bottom: 4, left: 0,
                        padding: '4px',
                        pointerEvents: 'none',
                        zIndex: 10,
                        textOverflow: 'ellipsis',
                        textShadow: '0 1px 3px rgba(0,0,0,0.9), 0 2px 8px rgba(0,0,0,0.8)'
                    } : {
                        borderRadius: '4px 0px 0px 4px',
                        background: '#0000008b',
                        color: '#fff',
                        position: 'absolute', top: '50px', right: 0,
                        padding: '8px 10px 9px',
                        pointerEvents: 'none',
                        zIndex: 10,
                        textOverflow: 'ellipsis',
                        textShadow: '0 1px 3px rgba(0,0,0,0.9), 0 2px 8px rgba(0,0,0,0.8)'
                    }}>
                        <div style={{
                            fontSize: '12px', fontWeight: 400,
                            lineHeight: 1.25, overflow: 'hidden', whiteSpace: 'nowrap'
                        }}>
                            {location ? location.location_name : 'Loading...'}
                        </div>
                        {site && (
                            <div style={{
                                fontSize: '12px', fontWeight: 400,
                                lineHeight: 1.25, overflow: 'hidden', whiteSpace: 'nowrap'
                            }}>
                                {site.site_name}
                            </div>
                        )}
                        {/* {props.isFeatured && site && location && location.location_lastupdate && (
                            <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: '11px', marginTop: '3px' }}>
                                <Moment format="MMM DD, YYYY HH:mm" tz={site.site_iana_timezone}>
                                    {location.location_lastupdate}
                                </Moment>
                            </div>
                        )} */}
                    </div>
                </div>

                <style>{`
                    .tile-stream .modal-header { display: none !important; }
                    .tile-stream .modal-body { padding: 0 !important; overflow: hidden !important; height: 100% !important; }
                    .tile-stream .modal-body .message-container { display: none !important; }
                    .tile-stream .modal-body > div:not(.message-container) { width: 100%; height: 100%; }
                    .tile-stream .modal-body video {
                        width: 100% !important; height: 100% !important; display: block !important;
                        object-fit: cover !important; max-height: none !important;
                    }
                    @keyframes livePulse {
                        0%, 100% { opacity: 1; }
                        50% { opacity: 0.3; }
                    }
                    .featured-stream .modal-header { display: none !important; }
                    .featured-stream .modal-body { padding: 0 !important; overflow: hidden !important; }
                    .featured-stream .modal-body .message-container { display: none !important; }
                    .featured-stream .modal-body > div:not(.message-container) { width: 100%; }
                    .featured-stream .modal-body video {
                        width: 100% !important; display: block !important;
                        max-height: none !important; overflow: visible !important;
                    }
                    /* natural — video drives its own height */
                    .featured-stream[data-fit="natural"] .modal-body video {
                        height: auto !important; object-fit: initial !important;
                    }
                    /* contain — full frame, black bars */
                    .featured-stream[data-fit="contain"] { height: 100%; }
                    .featured-stream[data-fit="contain"] .modal-body { height: 100%; }
                    .featured-stream[data-fit="contain"] .modal-body > div:not(.message-container) { height: 100%; }
                    .featured-stream[data-fit="contain"] .modal-body video {
                        height: 100% !important; object-fit: contain !important; background: #000;
                    }
                    /* cover — fills container, crops edges */
                    .featured-stream[data-fit="cover"] { height: 100%; }
                    .featured-stream[data-fit="cover"] .modal-body { height: 100%; }
                    .featured-stream[data-fit="cover"] .modal-body > div:not(.message-container) { height: 100%; }
                    .featured-stream[data-fit="cover"] .modal-body video {
                        height: 100% !important; object-fit: cover !important;
                    }
                `}</style>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div className={"card m-2 bg-shadow " + ((site && location) ? "cursor-pointer" : "cursor-loading") + (props.isFeatured ? " border border-primary" : "")}>
                <div className="card-body p-0">
                    <ImageResize className={"card-img-top img-fluid d-block " + (!turnOnVideoStreaming ? "" : "hide")} onClick={(e) => (site && location) && streamVideo(e)} src={image || no_image} resize_perc="0.2"></ImageResize>
                    {location && turnOnVideoStreaming ? ['axis', 'uniview'].includes(location.location_device_type) ?
                        <AxisLiveCameraFeed closeModal={() => setTurnOnVideoStreaming(false)} site={site} zone={location} user={user}></AxisLiveCameraFeed> :
                        <LiveCameraFeed closeModal={() => setTurnOnVideoStreaming(false)} site={site} zone={location} user={user}></LiveCameraFeed>
                        : <></>
                    }
                    <div className="card-img-overlay-custom text-right p-1">
                        {turnOnVideoStreaming && <button onClick={(e) => turnOnVideoStreaming ? stopVideo(e) : streamVideo(e)} className={enable_live_mode && enable_view_streaming ? "btn btn-xs btn-danger font-size-12 video-btn streaming-btn" : "btn btn-xs btn-danger font-size-12 hide video-btn streaming-btn"}><i className="fa fa-sm fa-circle pr-1" />{turnOnVideoStreaming ? "Stop Streaming" : "View Streaming"}</button>}
                    </div>
                </div>
                {site && location && <div className="card-header text-app">
                    <b className={"font-weight-700"}>
                        {site && site.site_name}
                        {props.isFeatured && <span className="badge badge-primary pull-right font-size-11"><i className="fa fa-video pr-1"></i> Featured</span>}
                        <br />
                        {location.location_name} &nbsp;
                        {
                            <span data-toggle="tooltip" title={location.location_operstatus === 'Connected' ? 'Active' : 'Inactive'}>
                                <Badge className={location.location_operstatus === 'Connected' ? "fa fa-lg fa-circle text-success" : "fa fa-lg fa-circle text-danger"} />
                            </span>
                        }
                    </b>
                    <span className={location.location_operstatus === 'Connected' ? 'text-success pull-right font-size-12' : 'text-danger pull-right font-size-12'}>
                        <span className="text-primary">
                            {CommonUtils.formatSensorData('temperature', temperature)}
                        </span>
                        <span className="ml-3 text-primary">
                            {CommonUtils.formatSensorData('humidity', humidity)}
                        </span>
                    </span>
                    <div className="text-dark">
                        <span className="font-size-12 font-weight-300">
                            <Moment format="MMM DD, YYYY HH:mm" tz={site.site_iana_timezone}>
                                {location.location_lastupdate}
                            </Moment>
                        </span>
                    </div>
                </div>
                }
            </div>
        </React.Fragment >
    )
}

export default LocationCard;